const printableNutritionTranslations = {
  meals: {
    title: "MEALS",
    mealNumber: {
      meal1: "Meal 1",
      meal2: "Meal 2",
      meal3: "Meal 3",
      meal4: "Meal 4",
    },
  },
  snacks: "SNACKS",
  loading: "Please wait while we load today’s menu...",
};

export default printableNutritionTranslations;
